const ORDER_TYPES = {
  INVALID: 0,
  // order by customer
  CUSTOMER_ORDER: 1,
  // order by admin as a customer
  ADMIN_ORDER: 2,
  // order by admin, inventory order
  INVENTORY_ORDER: 3,
};

const INOVICE_ITEM_TYPES = {
  BARCODE_ITEM: 'BARCODE_ITEM',
  ADDITIONAL_CHARGE: 'ADDITIONAL_CHARGE',
};

const TRANSACTION_ITEM_TYPES = {
  ORDER_ITEM: 'ORDER_ITEM',
  ADDITIONAL_CHARGE: 'ADDITIONAL_CHARGE',
};

const CHARGE_TYPE = {
  PERCENTAGE: 'PERCENTAGE',
  FIXED: 'FIXED',
};

const USER_ROLES = {
  ADMIN: 'admin',
  STAFF: 'staff',
  SALESPERSON: 'salesperson',
  CUSTOMER: 'customer',
  ADMIN_ONLY: ['admin'],
  ADMIN_AND_STUFF: ['admin', 'staff'],
  ADMIN_AND_SALESPERSON: ['admin', 'salesperson'],
  ALL_ROLES: ['admin', 'staff', 'salesperson', 'customer'],
  EXPCEPT_CUSTOMER: ['admin', 'staff', 'salesperson'],
};

const USER_ROLES_TYPES = {
  admin: 'ADMIN',
  staff: 'STAFF',
  salesperson: 'SALESPERSON',
  customer: 'CUSTOMER',
};

const CART_ITEM_TYPES = {
  IN_STOCK: 0,
  IN_PRODUCTION: 1,
  IN_PRODUCTION_CUSTOM: 2,
  ADD_INVENTORY: 3,
};

// Admin order list "Bulk Order" header filter
const BULK_ORDER_FILTER = {
  NOT_BULKED: 0,
  BULKED: 1,
  INVENTORY_ONLY: 2,
};

const BULK_ORDER_FILTER_LITERAL: Record<number, string> = {
  [BULK_ORDER_FILTER.NOT_BULKED]: 'Not Bulked',
  [BULK_ORDER_FILTER.BULKED]: 'Bulked',
  [BULK_ORDER_FILTER.INVENTORY_ONLY]: 'Inventory Only',
};

interface FulfillmentDatum {
  id: number;
  text: string;
  color: string;
}

const FULFILLMENT_DATA: FulfillmentDatum[] = [{
  id: 0,
  text: 'Unfulfilled',
  color: 'warning',
}, {
  id: 1,
  text: 'Partially Fulfilled',
  color: 'fulfillment_partial',
}, {
  id: 2,
  text: 'Fulfilled',
  color: 'success',
}, {
  id: 3,
  text: 'Canceled',
  color: 'fulfillment_cancelled',
}];

const FULFILLMENT_STATUS = FULFILLMENT_DATA
  .reduce<Record<string, number>>((acc, itm) => {
    acc[itm.text.replace(/ /g, '_').toUpperCase()] = itm.id;
    return acc;
  }, {});

const FULFILLMENT_COLOR = FULFILLMENT_DATA
  .reduce<Record<number, string>>((acc, itm) => {
    acc[itm.id] = itm.color;
    return acc;
  }, {});

const FULFILLMENT_LITERAL = FULFILLMENT_DATA
  .reduce<Record<number, string>>((acc, itm) => {
    acc[itm.id] = itm.text;
    return acc;
  }, {});

// Stable, locale-independent keys for each fulfillment status id. Customer-
// facing surfaces (storefront chips + order/password emails) translate via
// `order:status.<key>`; FULFILLMENT_LITERAL stays English for admin-only
// surfaces (CSV export, management UI) where US-only admins read English.
const FULFILLMENT_KEY = {
  0: 'unfulfilled',
  1: 'partiallyFulfilled',
  2: 'fulfilled',
  3: 'canceled',
};

// Market regions — each entry is the canonical code shown in the admin UI.
// REGION_LOCALE_MAP provides the *default* i18n locale for new users assigned
// to that region. An explicit user.locale (set by the language switcher) always
// takes precedence; this is only the fallback before the user makes a choice.
// When the full Market dimension lands, these codes will map to Market records
// and locale will be derived from Market.locale instead.
interface Region {
  code: string;
  label: string;
}

const REGIONS: Region[] = [
  { code: 'US', label: 'United States' },
  { code: 'FR', label: 'France' },
];

const REGION_LOCALE_MAP = {
  US: 'en',
  FR: 'fr',
};

// Coupon/Promotion constants
const COUPON_DISCOUNT_TYPES = {
  PERCENT: 'PERCENT',
  FIXED: 'FIXED',
};

const COUPON_TARGET_TYPES = {
  PRODUCT: 'PRODUCT',
  COLLECTION: 'COLLECTION',
  CART: 'CART',
};

const COUPON_ASSIGNMENT_TYPES = {
  ALL: 'ALL',
  SPECIFIC: 'SPECIFIC',
};

const COUPON_STATUS = {
  ACTIVE: 'ACTIVE',
  DISABLED: 'DISABLED',
};

const COUPON_VALIDATION_ERRORS = {
  EXPIRED: 'EXPIRED',
  NOT_STARTED: 'NOT_STARTED',
  DISABLED: 'DISABLED',
  ALREADY_USED: 'ALREADY_USED',
  NOT_ASSIGNED: 'NOT_ASSIGNED',
  MINIMUM_NOT_MET: 'MINIMUM_NOT_MET',
  NO_MATCHING_ITEMS: 'NO_MATCHING_ITEMS',
  INVALID_CODE: 'INVALID_CODE',
};

export {
  ORDER_TYPES,
  INOVICE_ITEM_TYPES,
  TRANSACTION_ITEM_TYPES,
  CHARGE_TYPE,
  USER_ROLES,
  USER_ROLES_TYPES,
  CART_ITEM_TYPES,
  BULK_ORDER_FILTER,
  BULK_ORDER_FILTER_LITERAL,
  FULFILLMENT_DATA,
  FULFILLMENT_STATUS,
  FULFILLMENT_COLOR,
  FULFILLMENT_LITERAL,
  FULFILLMENT_KEY,
  REGIONS,
  REGION_LOCALE_MAP,
  COUPON_DISCOUNT_TYPES,
  COUPON_TARGET_TYPES,
  COUPON_ASSIGNMENT_TYPES,
  COUPON_STATUS,
  COUPON_VALIDATION_ERRORS,
};
